import { FC } from 'react'
import createStandardIcon from './createStandardIcon'
import type { IconProps } from './type'

type Prop = {
  width?: number
  height?: number
  color?: string
}

export const ConnectIcon: FC<Prop> = (props) => {
  const { width = 24, height = 20 } = props

  return (
    <svg
      width={width}
      height={height}
      {...props}
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <rect width="24" height="20" rx="4" fill="#E1FAEA" />
      <mask id="mask0_10247_9509" maskUnits="userSpaceOnUse" x="4" y="2" width="16" height="16">
        <rect x="4" y="2" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10247_9509)">
        <path
          d="M8.69235 13.0259C7.85524 13.0259 7.14169 12.7309 6.55169 12.1409C5.96169 11.5511 5.66669 10.8376 5.66669 10.0006C5.66669 9.16361 5.96169 8.45005 6.55169 7.85994C7.14169 7.26972 7.85524 6.97461 8.69235 6.97461H10.7052C10.8469 6.97461 10.9656 7.02255 11.0614 7.11844C11.1572 7.21433 11.2052 7.33316 11.2052 7.47494C11.2052 7.61661 11.1572 7.73533 11.0614 7.83111C10.9656 7.92678 10.8469 7.97461 10.7052 7.97461H8.69152C8.13219 7.97461 7.65491 8.17228 7.25969 8.56761C6.86435 8.96294 6.66669 9.4405 6.66669 10.0003C6.66669 10.5601 6.86435 11.0376 7.25969 11.4329C7.65491 11.8283 8.13219 12.0259 8.69152 12.0259H10.7052C10.8469 12.0259 10.9656 12.0739 11.0614 12.1698C11.1572 12.2657 11.2052 12.3844 11.2052 12.5261C11.2052 12.6679 11.1572 12.7866 11.0614 12.8823C10.9656 12.9781 10.8469 13.0259 10.7052 13.0259H8.69235ZM10 10.5003C9.85835 10.5003 9.73963 10.4523 9.64385 10.3564C9.54796 10.2606 9.50002 10.1418 9.50002 10.0001C9.50002 9.85833 9.54796 9.73961 9.64385 9.64394C9.73963 9.54816 9.85835 9.50028 10 9.50028H14C14.1417 9.50028 14.2604 9.54822 14.3562 9.64411C14.4521 9.74 14.5 9.85878 14.5 10.0004C14.5 10.1422 14.4521 10.2609 14.3562 10.3566C14.2604 10.4524 14.1417 10.5003 14 10.5003H10ZM13.2949 13.0259C13.1532 13.0259 13.0345 12.978 12.9387 12.8821C12.8428 12.7862 12.7949 12.6674 12.7949 12.5256C12.7949 12.3839 12.8428 12.2652 12.9387 12.1694C13.0345 12.0738 13.1532 12.0259 13.2949 12.0259H15.3085C15.8679 12.0259 16.3451 11.8283 16.7404 11.4329C17.1357 11.0376 17.3334 10.5601 17.3334 10.0003C17.3334 9.4405 17.1357 8.96294 16.7404 8.56761C16.3451 8.17228 15.8679 7.97461 15.3085 7.97461H13.2949C13.1532 7.97461 13.0345 7.92666 12.9387 7.83078C12.8428 7.73489 12.7949 7.61611 12.7949 7.47444C12.7949 7.33266 12.8428 7.21394 12.9387 7.11828C13.0345 7.0225 13.1532 6.97461 13.2949 6.97461H15.3077C16.1448 6.97461 16.8584 7.26961 17.4484 7.85961C18.0384 8.4495 18.3334 9.16294 18.3334 9.99994C18.3334 10.8369 18.0384 11.5505 17.4484 12.1406C16.8584 12.7308 16.1448 13.0259 15.3077 13.0259H13.2949Z"
          fill="#018030"
        />
      </g>
    </svg>
  )
}